import { joinURL } from 'ufo'
import { createOperationsGenerator, defineProvider } from '@nuxt/image/runtime'

const operationsGenerator = createOperationsGenerator()

export default defineProvider<{
  baseURL?: string
}>({
  getImage(src, { modifiers, baseURL }) {
    const APP_ENV = process.env.APP_ENV
    if (APP_ENV === 'local') {
      return {
        url: src
      }
    }

    const { app } = useRuntimeConfig()
    if (!baseURL && app.cdnURL) baseURL = app.cdnURL
    if (!baseURL)
      return {
        url: src
      }

    const operations = operationsGenerator(modifiers)

    return {
      url:
        src.startsWith('https') ||
        src.startsWith('http') ||
        src.startsWith('blob') ||
        src.startsWith('data')
          ? src
          : joinURL(baseURL, src + (operations ? '?' + operations : ''))
    }
  }
})
